module.exports = __webpack_public_path__ + "static/media/covid19-popup-zh-HK-desktop.a82efff9.png";